exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".srm-sort-link {\n    color: white;\n    text-decoration: none;\n    font-weight: bold;\n}\n\n.srm-sort-link:hover,\n.srm-sort-link:focus {\n    color: white;\n    text-decoration: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/ticket-da-fatturare/ticket-da-fatturare.component.css
// module id = 360
// module chunks = 0